module.exports = __webpack_public_path__ + "img/icool-white.5fe7a71f.png";